import script from "./ProductImageImportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductImageImportPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductImageImportPage.vue?vue&type=style&index=0&id=0242d116&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0242d116"]])

export default __exports__